import { useEffect, useState } from "react";
import { Box, Card, CardHeader, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import _ from "lodash";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import PageLoading from "../../../../components/Loading/PageLoading";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import BASEURL from "../../../../pages/Utils/Baseurl";

import {
  allsalesorders,
  generateSalesorderPdf,
  updateSalesOrder,
} from "../salesOrderData/salesOrderData";
import request from "graphql-request";
import RoleAccess from "../../../function/RoleAccess";
import { MdChangeCircle } from "react-icons/md";
import { useLoading } from "../../../../context/LodingContext";
import { PiFilePdfFill } from "react-icons/pi";
import PDFURL from "../../../../pages/Utils/pdfurl";

const SalesOrderList = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const salesOrderListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S.NO",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Sales Order Id",
        field: "sio",
        name: "sio",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Customer Name",
        field: "customerName",
        name: "customerName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Order Type",
        field: "orderType",
        name: "orderType",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Order Date",
        field: "orderDate",
        name: "orderDate",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Total Amount",
        field: "totalAmount",
        name: "totalAmount",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Status",
        field: "status",
        name: "status",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created By",
        field: "createdBy",
        name: "createdBy",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "Created On",
        field: "createdOn",
        name: "createdOn",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },

      {
        headerName: "Action",
        field: "Action",
        name: "Action",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: data.map((v, i) => ({
      sno: i + 1,
      id: v.id,
      sio: v.soNumber,
      customerName: v.customer?.customerName,
      orderType: v?.orderType,
      orderDate: v?.orderDate,
      totalAmount: v?.totalAmount,
      createdBy: v?.user?.employeeName,
      createdOn: v?.createdAt?.slice(0, 10),
      status: (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "600",
              color:
                v?.status?.toLowerCase() === "pending"
                  ? "orange"
                  : v?.status?.toLowerCase() === "approved"
                  ? "#4caf50"
                  : "red",
            }}
          >
            {_.capitalize(v?.status)}
          </Typography>
          {v?.status?.toLowerCase() == "pending" && (
            <MdChangeCircle
              style={{
                cursor: "pointer",
                color: "grey",
                fontSize: "20px",
                marginLeft: "10px",
              }}
              onClick={() => handleChangeStatus(v?.id)}
            />
          )}
        </Box>
      ),

      Action: (
        <div
          style={{
            display: "flex",

            marginTop: "5px",
            alignItems: "center",
          }}
        >
          <RoleAccess modelName="Sales Order Screen" component="ViewSalesOrder">
            <VisibilityIcon
              fontSize="small"
              className="actionIcon"
              onClick={() =>
                navigate(`/sales-order/view-sales-order`, {
                  state: { type: "view", data: v },
                })
              }
            />
          </RoleAccess>

          {/* <RoleAccess
            modelName="Sales Order Screen"
            component="UpdateSalesOrder"
          >
            {v?.status?.toLowerCase() == "pending" && (
              <RoleAccess
                modelName="Sales Order Screen"
                component="UpdateSalesOrder"
              >
                <EditIcon
                  fontSize="small"
                  className="actionIcon"
                  onClick={() =>
                    navigate(`/sales-order/edit-sales-order`, {
                      state: { type: "edit", data: v },
                    })
                  }
                />
              </RoleAccess>
            )}
          </RoleAccess> */}

          <RoleAccess modelName="Sales Order Screen" component="PdfSalesOrder">
            <PiFilePdfFill
              fontSize="small"
              className="actionIcon"
              onClick={() => handleDownloadPdf(v?.id)}
            />
          </RoleAccess>

          {/* 
            <DeleteIcon
              style={{ color: "GrayText", fontSize: "20px" }}
              onClick={() => handleDelte(v?.id)}
            /> */}
        </div>
      ),
    })),
  };

  useEffect(() => {
    fetchSalesOrder();
  }, []);

  const fetchSalesOrder = async () => {
    setIsLoading(true);
    try {
      const res = await request(BASEURL, allsalesorders);

      if (res?.allsalesorders?.success) {
        setData(res?.allsalesorders?.data);
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = async (orderId) => {
    const { value: status } = await Swal.fire({
      title: "Change Status",
      input: "select",
      inputOptions: {
        Approved: "Approve",
        Rejected: "Reject",
      },
      inputPlaceholder: "Select a status",
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Cancel",
      inputValidator: (value) => {
        if (!value) {
          return "You need to select a status!";
        }
      },
    });

    if (status) {
      setCirleLoading(true);
      try {
        const res = await request(BASEURL, updateSalesOrder, {
          input: {
            salesOrderId: Number(orderId),
            status: status,
          },
        });

        const success = res?.updateSalesOrder?.success;

        if (success) {
          Swal.fire({
            position: "top",
            icon: "success",
            title: "Status Change Successfully",
            showConfirmButton: true,
          }).then(() => {
            fetchSalesOrder();
          });
        }
      } catch (err) {
      } finally {
        setCirleLoading(false);
      }
    }
  };

  const handleDownloadPdf = async (id) => {
    setCirleLoading(true);

    try {
      const res = await request(BASEURL, generateSalesorderPdf, {
        id: Number(id),
      });

      const success = res?.generateSalesorderPdf?.success;
      const message = res?.generateSalesorderPdf?.message;
      const pdfUrl = `${PDFURL}${res?.generateSalesorderPdf?.pdfUrl}`;

      if (success && pdfUrl) {
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", "SalesOrder.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error downloading PDF:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Sales Order List
                </MaterialTypography>
              </Stack>
              <RoleAccess
                modelName="Sales Order Screen"
                component="CreateSalesOrder"
              >
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/sales-order/add-sales-order", {
                      state: { type: "add" },
                    })
                  }
                >
                  Sales Order
                </MaterialButton>
              </RoleAccess>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            // customHeight={550}
            rows={salesOrderListTable.rows}
            columns={salesOrderListTable.columns}
            // checkboxSelection={false}
            isSelectable={false}
            // onRowClick={onCustomerListClick}
            //   loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Sales Order found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet add any sales order details. Click on the
                    "Add sales order" button to start adding sales order
                    details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
        {isLoading && <PageLoading />}
      </Card>
    </DashboardLayout>
  );
};

export default SalesOrderList;
